function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96.1,368.34l7.81-2.81a123.17,123.17,0,0,0-.53-28.18C100.21,316.37,85,298.52,72,296c-16.76-3.22-14.2,12.35-4.77,19.3C82.27,326.39,93.79,343,96.1,368.34Z"
});
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-326"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-326",
    cx: 249.95,
    cy: 355.92,
    rx: 208.26,
    ry: 123.53,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-326"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-326",
    cx: 128.33,
    cy: 385.43,
    rx: 62.21,
    ry: 35.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-326",
    d: "M331.32,441.66a13.29,13.29,0,0,1-6.54-1.63L157.94,343.7a7.26,7.26,0,0,1,0-13.09l100.67-58.12a13.88,13.88,0,0,1,13.09,0l166.84,96.32c2.62,1.51,5.91,2.95,5.91,6.55s-3.29,5-5.91,6.54L337.87,440A13.33,13.33,0,0,1,331.32,441.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.49,334.88l-12.33-7.11s-4-19.24-1.3-38.54c4.53-32.89,22.39-37.81,29.21-35.48s8.83,10.25-2.41,26.51C421,289.85,412.92,309.82,414.49,334.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,324.13h.08a.62.62,0,0,0,.52-.69c-3.59-25.32,6.5-53.11,17.91-64.34a.6.6,0,0,0,0-.85.59.59,0,0,0-.85,0c-11.62,11.43-21.91,39.68-18.27,65.37A.6.6,0,0,0,406.74,324.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34,348c1.38.69,5-2.45,6-3.21a12.78,12.78,0,0,0,4-5.1,12,12,0,0,0,.67-7.24,28,28,0,0,0-1.11-3.77L445.67,325a9.19,9.19,0,0,1-.74-3.7c.18-2.56,2.34-4.45,4.3-6.09,2.17-1.82,4.41-4.18,4.23-7.23a10.7,10.7,0,0,0-3-6.24c-1.55-1.77-3.37-3.31-4.8-5.19a7.58,7.58,0,0,1-1.79-4.66,7.85,7.85,0,0,1,.88-3c1-2,2.29-3.94,2.92-6.11s.38-4.83-1.36-6.27c-1.44-1.18-3.48-1.24-5.32-1a12.1,12.1,0,0,0-4.8,2c-4.69,2.95-7.15,8.84-12.18,11.18-1.94.91-4.1,1.2-6.14,1.86s-4.09,1.82-4.95,3.79c-1.87,4.31,2.55,8.42-.58,12.61-1,1.3-2.23,2.35-3.26,3.59-2.91,3.52-4.2,7.21-3.38,12.92a14.29,14.29,0,0,0,6.49,10.12S437.13,347.88,437.34,348Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,341.08h0a.61.61,0,0,0,.55-.66c-2.28-23.89,7.59-50.93,15.39-59.05a.61.61,0,1,0-.88-.84c-7.95,8.28-18,35.77-15.71,60A.6.6,0,0,0,424,341.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,311.6l.18,0a81.15,81.15,0,0,1,17.23-3.73.61.61,0,0,0,.54-.66.59.59,0,0,0-.65-.55,82.9,82.9,0,0,0-17.54,3.8.61.61,0,0,0-.35.78A.59.59,0,0,0,426.27,311.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.1,368.34l7.81-2.81a123.17,123.17,0,0,0-.53-28.18C100.21,316.37,85,298.52,72,296c-16.76-3.22-14.2,12.35-4.77,19.3C82.27,326.39,93.79,343,96.1,368.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref2), /*#__PURE__*/React.createElement("path", {
    d: "M99.93,367.37l-.09,0a.91.91,0,0,1-.7-1.09c4.19-19.2-10.7-55.43-31.66-66.18a.92.92,0,0,1,.84-1.64c21.6,11.08,36.93,48.43,32.61,68.21A.92.92,0,0,1,99.93,367.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09,366.54c.38-2.27.61-5.61.68-6.43a21.16,21.16,0,0,0-1-8.58,16.81,16.81,0,0,0-6.89-8.85c-1.76-1.09-3.83-1.9-5-3.64-1-1.5-1-3.38-1.17-5.15-.27-2.9-1.09-6-3.35-7.8s-5.39-2-8.27-1.74c-4.15.32-8,.77-11.85-1.23a83.42,83.42,0,0,0-9.42-4.57c-4.09-1.54-13.3-3.83-15.41,1.92a5.61,5.61,0,0,0,.71,4.76,16.4,16.4,0,0,0,3.38,3.63l6.31,5.57a8.15,8.15,0,0,1,1.91,2.11c1.2,2.18.23,4.88.44,7.36A8.77,8.77,0,0,0,56,350.19a11.81,11.81,0,0,0,7.19,1.95c3.38-.13,9-2.57,10.92,1.48a12.73,12.73,0,0,1,.88,4.3,8.25,8.25,0,0,0,1.28,4.17c1.3,1.72,3.62,2.27,5.76,2.55,3,.4,6.08.51,8.86,1.69,1.14.48,1.83,2,2.48,3C95.48,368.59,97.82,367.81,101.09,366.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,368.66a.85.85,0,0,1-.71-.54c-7.64-20.19-25.81-36.33-51.16-45.45a.84.84,0,0,1,.57-1.58c25.82,9.29,44.34,25.78,52.16,46.44a.85.85,0,0,1-.49,1.08A1,1,0,0,1,97.4,368.66Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Platform--inject-326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bench--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.09,431.89,162.25,335.56a9.17,9.17,0,0,1-4.15-7.19V306.5a9.17,9.17,0,0,1,4.15-7.19l100.67-58.12a9.13,9.13,0,0,1,8.3,0l166.84,96.32a9.17,9.17,0,0,1,4.15,7.19v21.87a9.17,9.17,0,0,1-4.15,7.19L337.39,431.89A9.19,9.19,0,0,1,329.09,431.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.21,344.7v21.88a9.16,9.16,0,0,1-4.15,7.18L337.39,431.88a8.44,8.44,0,0,1-4.15,1V401.42a8.52,8.52,0,0,0,4.15-1L438.06,342.3c2.15-1.24,2.29-3.19.42-4.52A9.23,9.23,0,0,1,442.21,344.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,401.42v31.46a8.41,8.41,0,0,1-4.15-1L162.25,335.56a9.14,9.14,0,0,1-4.15-7.18V306.49a9.26,9.26,0,0,1,3.73-6.91c-1.86,1.33-1.71,3.28.42,4.52l166.85,96.33A8.52,8.52,0,0,0,333.24,401.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,342.3,337.39,400.43a9.19,9.19,0,0,1-8.3,0L162.25,304.1c-2.29-1.32-2.29-3.47,0-4.79l100.67-58.12a9.13,9.13,0,0,1,8.3,0l166.84,96.32C440.35,338.83,440.35,341,438.06,342.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.07,339.83c-2.19-1.27-4.23-1.32-5.89-.35-.56.32-2.89,1.64-3.49,2-1.81,1.12-3.14,3.48-3.66,6.84a11.89,11.89,0,0,0-2.12-2.44l.6-.34c1.2-.7,1.77-2.46,1.77-4.83,0-5.78-2.68-9.28-6.08-11.24L198.08,326l-2.87,1.65v-3.31l-4.5-2.59-3.36,1.94v7l-4.53-13.52-4.5-2.59L175,316.48v3.28c-1.72-5.65-4.9-10.54-8.55-12.65a5.68,5.68,0,0,0-5.79-.39v0l-.13.07h0l-3.29,1.89c-1.71.84-4.11,3.87-4.11,10.38,0,8.87,4.12,18.13,10,21.5,2.27,1.31,4.3,1.38,5.93.43.56-.33,2.74-1.59,3.28-1.89a6.67,6.67,0,0,0,2.7-3.15v10.94l4.5,2.59,3.36-1.94v-7L187.35,354l4.5,2.59,2.87-1.65v3.31l7.49,4.32c1.84,1.07,3.33,1.23,4.41.62.59-.32,2.86-1.65,3.42-2a3,3,0,0,0,1-.91c1.63,5.71,4.78,10.66,8.71,12.94,2.19,1.26,4.16,1.36,5.76.52.63-.33,2.9-1.69,3.44-2,2.51-1.37,4.09-5.11,4.09-10.52C233,352.41,228.55,343,223.07,339.83Zm-55.67-7.5a5.12,5.12,0,0,1-1-.43c-3.68-2.13-5.09-7.47-5.09-12a12.23,12.23,0,0,1,.76-4.6,4.19,4.19,0,0,1,1,.42c3.49,2,5.07,7.46,5.07,12A12.85,12.85,0,0,1,167.4,332.33Zm35.18,21.26v-2.86a5.89,5.89,0,0,1,1.32,3.63Zm21.48,11.46a4.64,4.64,0,0,1-1-.44c-3.68-2.12-5.09-7.47-5.09-12a12.23,12.23,0,0,1,.76-4.6,5.27,5.27,0,0,1,1,.42c3.5,2,5.07,7.46,5.07,12A12.9,12.9,0,0,1,224.06,365.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,413l3.28-1.86L332,407.9c-1.72-4.2-4.13-7.59-7.6-9.59-2.07-1.19-3.93-1.28-5.45-.48-.63.34-3,1.71-3.56,2.05a6.81,6.81,0,0,0-2.59,3.13V392.17l-4.5-2.6-3.36,1.94v7L300.38,385l-4.5-2.59L293,384.08v-3.32l-4.49-2.59-3.36,1.93v3.49c-1.75-5.53-5-10.23-8.58-12.32l-5.72-3.3-3.35,1.94v21.94l-4.1-9.94L265,381c1.39-.78,2.24-2.8,2.24-6.1,0-6-2.78-10.63-6.44-12.74l-7.05-4.07L250.38,360v16.62L245,353l-4.16-2.4-3.36,1.94-8,25.79,4.83,2.79,3.36-1.94.53-1.9,5.08,2.94,1.46,6.91,4.83,2.79.77-.44v.89l4.5,2.59,3.36-1.94v-1.43l2.66,6.85,5.72,3.3.89-.51v1l5.71,3.31c2.24,1.29,4.33,1.41,6,.49l3.48-2a6.52,6.52,0,0,0,2.45-2.81v11.24l4.49,2.59,2.87-1.65v3.31l4.5,2.6,3.36-1.94v-7l4.53,13.51,4.5,2.6,3.36-1.94v-3.23c1.68,5.55,4.73,10.39,8.24,12.42,2,1.16,4.11,1.48,5.8.52.57-.32,2.72-1.6,3.26-1.89,1.61-.85,2.88-2.82,3.41-6.29v-6.59Zm-67-38.56-.52-.31V371a6.88,6.88,0,0,1,.89,3.63v.09Zm16.6,7.14a17.22,17.22,0,0,1,3,9.75,10.34,10.34,0,0,1-.83,4.36,4.8,4.8,0,0,1-1.44-.55l-.69-.41Zm50.19,40.53a7.07,7.07,0,0,1-.2,1.77,3.84,3.84,0,0,1-.72-.33,8.76,8.76,0,0,1-3.08-3.75Zm-1.18-9.91L321,414.17v4.43a20.14,20.14,0,0,1-1.4-7.27,11.82,11.82,0,0,1,.93-5,4.09,4.09,0,0,1,.73.31c1.72,1,3.21,2.9,4.35,6.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.71,341.77c5.48,3.16,9.93,12.58,9.93,21.45,0,5.41-1.58,9.15-4.1,10.52.71-.38,2.85-1.65,3.37-1.94,2.51-1.37,4.09-5.11,4.09-10.52,0-8.87-4.45-18.29-9.93-21.45-2.19-1.27-4.23-1.32-5.89-.35-.56.32-2.89,1.64-3.49,2h0C215.35,340.45,217.45,340.46,219.71,341.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,353.59v-2.86a7.51,7.51,0,0,0-2-1.57l-1.41-.81v7.18l1.41.81c2.13,1.23,3.3.91,3.3-1.48,0-.18,0-.34,0-.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.31 342.46 187.35 342.49 187.35 330.65 182.82 317.14 178.32 314.55 174.97 316.49 179.46 319.08 187.31 342.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.46 319.08 182.82 317.14 187.35 330.65 187.35 342.49 179.46 319.08",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,340.85a5.27,5.27,0,0,0-3-4.82l-.36-.2v6.55l.36.21C201.51,343.71,202.57,343.39,202.57,340.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,348.34a11.31,11.31,0,0,0-2.11-2.44l.62-.36c1.18-.7,1.75-2.45,1.75-4.81,0-5.78-2.68-9.28-6.08-11.24L198.08,326l-2.87,1.65v-3.31l-4.5-2.59-3.36,1.94,4.5,2.59v30.38h0l2.87-1.65V327.89l6.12,3.54c3.4,2,6.08,5.45,6.08,11.24,0,2.79-.79,4.73-2.47,5.09,2.47,2.09,4.21,5.19,4.21,10.09,0,2.78-.73,4.65-2.07,5.38l0,0c.59-.32,2.86-1.65,3.42-2a3,3,0,0,0,1-.91,31.36,31.36,0,0,1-1.23-8.57A22.56,22.56,0,0,1,210,348.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.07,364.61c-3.68-2.12-5.09-7.47-5.09-12a12.23,12.23,0,0,1,.76-4.6c.15.05.3.1.46.17-3.11-1.37-4.58,2.08-4.58,6.37,0,4.53,1.41,9.88,5.09,12,2.19,1.26,3.59.39,4.35-1.5A4.64,4.64,0,0,1,223.07,364.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,307.11c-2.15-1.24-4.14-1.31-5.78-.41h0l-.19.11-3.21,1.84a5,5,0,0,1,1.77-.59,6.5,6.5,0,0,1,4.07,1c5.47,3.17,9.92,12.58,9.92,21.46,0,5.36-1.56,9.08-4,10.48l0,0c.56-.33,2.73-1.59,3.27-1.89a6.68,6.68,0,0,0,2.71-3.15V319.75C173.24,314.1,170.05,309.21,166.41,307.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.32,319.9a12.23,12.23,0,0,1,.76-4.6,4,4,0,0,1,.45.16c-3.11-1.36-4.57,2.08-4.57,6.38,0,4.53,1.41,9.87,5.09,12,2.18,1.26,3.58.38,4.35-1.51a5.12,5.12,0,0,1-1-.43C162.73,329.77,161.32,324.43,161.32,319.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,381.91,265,381c1.39-.78,2.24-2.8,2.24-6.1,0-6-2.78-10.63-6.44-12.74l-7.05-4.07L250.38,360l7.06,4.07c3.65,2.11,6.43,6.77,6.43,12.74,0,4.56-1.63,6.68-4,6.46l6.79,16.48h0l.89-.51v-7.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,406.35l.33.12c-2.58-1.11-4.62,1.79-4.62,6.8s2.25,10.65,5,12.25c1.76,1,3.5.59,4.08-1.61a3.84,3.84,0,0,1-.72-.33,8.76,8.76,0,0,1-3.08-3.75l-.54-.32v-.91a20.14,20.14,0,0,1-1.4-7.27A11.82,11.82,0,0,1,320.54,406.35Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58,371.27l-5.72-3.3-3.35,1.94,5.71,3.3c5.41,3.12,9.95,12.08,9.95,20.92,0,5.42-1.69,8.9-4.24,10.09l.3-.13,3.48-2a6.52,6.52,0,0,0,2.45-2.81V383.59C283.41,378.06,280.19,373.36,276.58,371.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,394.76V381.61a8.75,8.75,0,0,0-2.66-2.51l-.7-.4v18l.7.4c2.14,1.24,3.84.59,4.79-1.38a4.8,4.8,0,0,1-1.44-.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.88 393 254.88 393 258.24 391.06 258.24 389.63 254.88 381 254.88 393",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.02 386.95 304.86 410.34 304.91 410.37 304.91 398.53 300.38 385.01 295.88 382.42 293.01 384.08 293.01 380.76 288.52 378.17 285.16 380.11 289.65 382.7 289.65 413.08 289.65 413.08 292.52 411.43 292.52 384.36 297.02 386.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.81 375.92 234.35 381.15 234.35 381.15 237.71 379.22 238.24 377.32 235.81 375.92",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.54 363.16 237.34 370.73 241.79 373.3 239.59 363.19 239.54 363.16",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.02 398.48 297.02 417.33 297.02 417.34 300.38 415.4 300.38 408.38 297.07 398.51 297.02 398.48",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.77,403V392.17l-4.5-2.6-3.36,1.94,4.5,2.6v30.38h0l3.36-1.94v-3.23a30.78,30.78,0,0,1-1.37-8.86A17.92,17.92,0,0,1,312.77,403Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.01 353.05 240.84 350.64 237.49 352.58 241.65 354.98 249.61 389.96 249.61 389.96 250.38 389.52 250.38 376.65 245.01 353.05",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,374.16V371a7.4,7.4,0,0,0-2.84-2.5l-.52-.3v8l.52.3c1.68,1,3.69,2,3.73-1.73l-.37-.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,413l3.28-1.86L332,407.9c-1.72-4.2-4.13-7.59-7.6-9.59-2.07-1.19-3.93-1.28-5.45-.48-.57.31-2.57,1.47-3.36,1.93,1.53-.8,3.38-.7,5.45.49,3.47,2,5.88,5.39,7.6,9.58l-2.94,3.28a1,1,0,0,1-.05-.16l-1.25-.72L321,414.17l9.11,5.26V426c-.52,3.44-1.78,5.41-3.37,6.27l.06,0c.57-.32,2.72-1.6,3.26-1.89,1.61-.85,2.88-2.82,3.41-6.29v-6.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,335.93V319.75c-.22-.74-.48-1.47-.75-2.18l-3.36,1.92a31,31,0,0,1,2.13,11c0,5.36-1.56,9.08-4,10.48l0,0c.56-.33,2.74-1.59,3.28-1.89A6.67,6.67,0,0,0,175,335.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.85 326.23 195.21 324.29 195.21 327.6 194.72 327.89 194.72 354.95 191.85 356.61 191.85 326.23",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.65 354.98 245.01 353.05 250.38 376.65 250.38 389.52 249.61 389.96 241.65 354.98",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,381.91l-1.71,1a2.65,2.65,0,0,1-1.87.4l6.79,16.48.89-.51v-7.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.01 380.76 289.65 382.7 289.65 413.08 292.52 411.43 292.52 384.36 293.01 384.08 293.01 380.76",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.02 386.95 300.38 385.01 304.91 398.53 304.91 410.37 297.02 386.95",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.61 409.83 331.97 407.89 329.03 411.17 325.67 413.11 328.61 409.83",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,426c-.52,3.44-1.78,5.41-3.37,6.27l.06,0c.57-.32,2.72-1.6,3.26-1.89,1.61-.85,2.88-2.82,3.41-6.29v-6.59l-3.36,1.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,394.13c0,5.42-1.69,8.9-4.24,10.09l.3-.13,3.48-2a6.52,6.52,0,0,0,2.45-2.81V383.59c-.19-.59-.39-1.17-.61-1.73l-3.36,1.93A29.24,29.24,0,0,1,283.17,394.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,361.28a31,31,0,0,0-2-10.59l-3.36,1.94a31,31,0,0,1,2,10.59c0,5.41-1.58,9.15-4.1,10.52.71-.38,2.85-1.65,3.37-1.94C231.42,370.43,233,366.69,233,361.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.66,357.85c0,2.78-.73,4.65-2.07,5.38l0,0c.59-.32,2.86-1.65,3.42-2a3,3,0,0,0,1-.91,31.36,31.36,0,0,1-1.23-8.57,22.56,22.56,0,0,1,.25-3.41,11.31,11.31,0,0,0-2.11-2.44l-2.71,1.57-.1,0a.61.61,0,0,1-.14.07,1.73,1.73,0,0,1-.51.18C206.92,349.85,208.66,353,208.66,357.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.46 330.61 179.46 349.46 179.46 349.46 182.82 347.52 182.82 340.51 179.51 330.63 179.46 330.61",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,394.11v30.38l3.36-1.94v-3.23a30.78,30.78,0,0,1-1.37-8.86,17.92,17.92,0,0,1,1.37-7.45V392.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,309.05c5.48,3.17,9.93,12.58,9.93,21.46s-4.26,13.3-9.93,10c-5.83-3.37-10-12.63-10-21.5S157.62,305.92,163.05,309.05Zm0,24.79c3.59,2.07,5.07-1.6,5.07-6.13s-1.58-10-5.07-12-5.09,1.59-5.09,6.12S159.37,331.71,163.05,333.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,349.46l-4.5-2.59V316.48l4.5,2.6,7.84,23.38,0,0V323.64l4.5,2.59v30.38l-4.5-2.59-7.84-23.39,0,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.84,331.43c3.4,2,6.08,5.45,6.08,11.24,0,2.79-.79,4.73-2.47,5.09,2.47,2.09,4.21,5.19,4.21,10.09s-2.36,7.11-6.45,4.74l-7.49-4.32V327.89Zm-1.26,11.16c1.93,1.12,3,.8,3-1.74a5.27,5.27,0,0,0-3-4.82l-.36-.2v6.55Zm1,13.75c2.13,1.23,3.3.91,3.3-1.48a6,6,0,0,0-3.3-5.7l-1.41-.81v7.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.71,341.77c5.48,3.16,9.93,12.58,9.93,21.45s-4.26,13.31-9.93,10c-5.83-3.36-9.94-12.63-9.94-21.5S214.29,338.63,219.71,341.77Zm0,24.78c3.59,2.07,5.07-1.6,5.07-6.13s-1.57-10-5.07-12-5.09,1.59-5.09,6.12S216,364.43,219.71,366.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,390l-4.83-2.79-1.46-6.91-7.51-4.34-1.46,5.24-4.83-2.79,8-25.79,4.16,2.4Zm-10-26.77-.05,0-2.2,7.57,4.45,2.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.44,364.1c3.65,2.11,6.43,6.77,6.43,12.74,0,4.56-1.63,6.68-4,6.46l6.79,16.48-5.72-3.3-6-15.48v12l-4.5-2.59V360Zm-2,12.3c1.7,1,3.73,2,3.73-1.82s-2-5.15-3.73-6.13l-.52-.3v8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,373.21c5.41,3.12,9.95,12.08,9.95,20.92s-4.52,12.6-9.95,9.46l-5.71-3.3V369.91Zm-.52,23.89c3.32,1.92,5.59-.67,5.62-5.74S276,381,272.7,379.1l-.7-.4v18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,413.08l-4.49-2.59V380.1l4.49,2.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,417.34l-4.5-2.6V384.36L297,387l7.84,23.39.05,0V391.51l4.5,2.6v30.38l-4.5-2.6-7.84-23.38-.05,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,426c-1.08,7.08-5.24,8-9.11,5.72-5.31-3.07-9.61-12.59-9.61-21.28s4.06-13.41,9.61-10.21c3.47,2,5.88,5.39,7.6,9.58l-2.94,3.28c-1.15-3.5-2.65-5.44-4.4-6.45-2.77-1.6-5,1.34-5,6.61s2.25,10.65,5,12.25c2.16,1.24,4.28.33,4.28-3.39L321,419.51v-5.34l9.11,5.26Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-326",
    cx: 241.65,
    cy: 302.27,
    rx: 47.42,
    ry: 27.38,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-326",
    cx: 330.11,
    cy: 351.29,
    rx: 53.29,
    ry: 30.77,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.46,24.85,189,45.29a3.14,3.14,0,0,1,1.42,2.46V96.28a3.09,3.09,0,0,1-1.43,2.44l-5.07,2.85a3.21,3.21,0,0,1-2.85,0L145.54,81.11a3.11,3.11,0,0,1-1.42-2.46V30.12a3.1,3.1,0,0,1,1.42-2.44l5.08-2.85A3.16,3.16,0,0,1,153.46,24.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.44,100.73V52.2A3.11,3.11,0,0,0,181,49.75L145.54,29.3c-.79-.45-1.42-.08-1.42.82V78.65a3.11,3.11,0,0,0,1.42,2.46L181,101.55C181.81,102,182.44,101.64,182.44,100.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,101.55a3.24,3.24,0,0,0,2.85,0l5.07-2.85a3.09,3.09,0,0,0,1.43-2.44V47.74a3,3,0,0,0-.45-1.44L182,50.81a2.84,2.84,0,0,1,.42,1.39v48.53C182.44,101.56,181.86,102,181,101.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,29.86c.11-.71.69-1,1.4-.56L181,49.75a2.84,2.84,0,0,1,1,1.06l7.91-4.51a2.88,2.88,0,0,0-1-1L153.46,24.84a3.16,3.16,0,0,0-2.84,0l-5.08,2.85A3.12,3.12,0,0,0,144.14,29.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25,83.74c.89-.53,7.56-4.29,7.78-4.41a1.32,1.32,0,0,0,.28-2L190.25,62.26l-7.81,4.43L194.5,81.75A1.35,1.35,0,0,1,194.25,83.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25,83.74c.89-.53,7.56-4.29,7.78-4.41a1.32,1.32,0,0,0,.28-2L190.25,62.26l-7.81,4.43L194.5,81.75A1.35,1.35,0,0,1,194.25,83.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.44,66.7l12.06,15a1.27,1.27,0,0,1-.81,2.17l-11.25,1.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.73,57.59c0-2.8,1.48-4.22,3.3-3.17s3.29,4.17,3.29,7-1.47,4.22-3.29,3.17S159.73,60.39,159.73,57.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,82.46l-8-4.62a4.85,4.85,0,0,1-1.79-4.18l.38-4.32c.27-3.12,2.09-4.53,4.24-3.29l2.34,1.35c2.15,1.25,4,4.75,4.24,8.19l.38,4.76C169,82.09,168.12,83.09,167,82.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,57.17c0-3.08,1.62-4.64,3.62-3.48s3.62,4.59,3.62,7.66-1.62,4.64-3.62,3.49S168.3,60.25,168.3,57.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,84.36,170.8,81.3l-.38-4.74A17.88,17.88,0,0,0,166.7,67a2.58,2.58,0,0,1,3.71-.66L173,67.83c2.36,1.37,4.35,5.21,4.65,9l.42,5.22C178.22,84,177.29,85.05,176.09,84.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27,52.5c0-2.93-1.54-6.19-3.44-7.28s-3.44.38-3.44,3.31,1.54,6.18,3.44,7.28S158.27,55.43,158.27,52.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,63.61c-1.87.08-3.27,1.91-3.54,5l-.36,4.08-5-2.9A5,5,0,0,1,149,65.41l.4-4.49c.28-3.27,2.18-4.73,4.42-3.44l2.45,1.42A9.28,9.28,0,0,1,159.79,63.61Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.43,113.82V99.69l-11.93-1a.82.82,0,0,0-.5.1c-.46.25-10.07,5.78-10.22,5.87a.87.87,0,0,0-.19,1.34l12.64,13.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.23,119.68,380.59,106a.87.87,0,0,1,.71-1.46l11.93,1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.42,99.69l-10.19,5.86-11.93-1a.91.91,0,0,0-.41.06c.95-.56,9.68-5.58,10.11-5.81a.82.82,0,0,1,.5-.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.42,99.69l-10.19,5.86-11.93-1a.91.91,0,0,0-.41.06c.95-.56,9.68-5.58,10.11-5.81a.82.82,0,0,1,.5-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,80.7l35.49,20.44a3.17,3.17,0,0,1,1.42,2.46v48.53a3.07,3.07,0,0,1-1.43,2.44l-5.08,2.85a3.19,3.19,0,0,1-2.84,0L394.5,137a3.14,3.14,0,0,1-1.42-2.45V86a3.1,3.1,0,0,1,1.43-2.44l5.08-2.84A3.16,3.16,0,0,1,402.43,80.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41,156.59V108.05A3.14,3.14,0,0,0,430,105.6L394.5,85.15c-.78-.45-1.42-.08-1.42.82v48.54A3.14,3.14,0,0,0,394.5,137L430,157.41C430.77,157.86,431.41,157.49,431.41,156.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,157.41a3.25,3.25,0,0,0,2.84,0l5.08-2.85a3.1,3.1,0,0,0,1.43-2.43V103.6a2.9,2.9,0,0,0-.46-1.45L431,106.66a2.84,2.84,0,0,1,.42,1.39v48.53C431.41,157.41,430.82,157.89,430,157.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,85.72c.11-.72.7-1,1.4-.57L430,105.6a3,3,0,0,1,1,1.06l7.9-4.51a2.86,2.86,0,0,0-1-1L402.43,80.7a3.19,3.19,0,0,0-2.84,0l-5.08,2.85A3.15,3.15,0,0,0,393.1,85.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.71,117.21l1.49,5a.93.93,0,0,0,.66.56l2.94.71a1.27,1.27,0,0,1,.75.55,24.39,24.39,0,0,0,1.58,2.75,1.08,1.08,0,0,1,.17.78l-.95,3.23a.87.87,0,0,0,.26.75l3.44,3.64a.43.43,0,0,0,.5.15.23.23,0,0,0,.07-.07l1.61-2.45c.11-.18.4-.16.66,0s.64.41.95.59.66.37,1,.53a1.48,1.48,0,0,1,.69.66l1.69,4.55a.89.89,0,0,0,.69.47l3.13.31a.39.39,0,0,0,.29,0h0a.28.28,0,0,0,.13-.31l-1-4.48a.5.5,0,0,1,.33-.56,4.92,4.92,0,0,0,1.36-.8.58.58,0,0,1,.7.12l3.2,2.92a.55.55,0,0,0,.35.17h0l.12,0h0a.24.24,0,0,0,.08-.09l1.43-3.15a.81.81,0,0,0-.19-.74l-3-3.64a1.23,1.23,0,0,1-.29-.79,14.84,14.84,0,0,0,0-2.58.43.43,0,0,1,.45-.44l2.69-.15c.27,0,.44-.22.36-.45l-1.48-5a.93.93,0,0,0-.66-.55l-2.94-.71a1.28,1.28,0,0,1-.75-.56,24.26,24.26,0,0,0-1.58-2.74,1.1,1.1,0,0,1-.17-.78l1-3.24a1,1,0,0,0-.27-.76l-3.44-3.63c-.2-.21-.46-.25-.58-.07l-1.6,2.44c-.11.18-.4.16-.67,0a14.41,14.41,0,0,0-1.93-1.13,1.43,1.43,0,0,1-.69-.66l-1.69-4.55a.89.89,0,0,0-.69-.47l-3.13-.31a.45.45,0,0,0-.29,0,.26.26,0,0,0-.14.31l1,4.48a.51.51,0,0,1-.32.56,4.83,4.83,0,0,0-1.37.8.57.57,0,0,1-.7-.12l-3.2-2.92c-.17-.15-.34-.2-.46-.14h0a.2.2,0,0,0-.09.09l-1.42,3.15a.85.85,0,0,0,.18.75l3,3.62a1.27,1.27,0,0,1,.29.8c0,.43-.06.88-.06,1.33s0,.83.07,1.25a.44.44,0,0,1-.46.44l-2.68.15a.53.53,0,0,0-.19,0h0A.34.34,0,0,0,397.71,117.21Zm11.78,9.14c-3.21-3.38-4.73-8.51-3.4-11.44a3.14,3.14,0,0,1,2.46-2h.12l.11,0h.14a4.93,4.93,0,0,1,2.22.48,6.52,6.52,0,0,1,.79.4,10.86,10.86,0,0,1,2.37,1.92,14,14,0,0,1,3.88,8.89,6.66,6.66,0,0,1-.05.91,5.57,5.57,0,0,1-.43,1.64,3.15,3.15,0,0,1-2.95,2h-.29l-.33,0-.27-.05-.13,0-.17,0A8.88,8.88,0,0,1,409.49,126.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.9,122.25c-6.6,1.3-10.87,4.78-12.29,15.12-1.69,12.42-4.39,31.51-4.39,31.51s-8.77,24.85-13.24,30.43a30.6,30.6,0,0,1-4.26,4.07c-4.11,5.15-13.67,8.58-9.33,11.48,3.33,2.22,8.36,2.66,13.12,0,6.43-3.58,9.06-7.71,12.25-13,4-6.59,17.73-31.25,17.73-31.25Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.57,196.86c-.85,1.42-3.78,1.77-6.57,2.33s-4.93,2.2-6.87,2.6c-1.67.34-1.19,2.33,1.79,2.49s6.49-2.11,7.07,0S291.08,200.64,289.57,196.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.4,183.38l-1.78,4.14c2.85.19,9.78,3.65,11,6l2.45-4.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,122.25s-6.71-.21-9.95,5.55-7.25,41-7.25,41l-6.47,16.41c2.73-.19,11.09,4.07,12.17,6.66l11.28-18.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.73,
    y: 336.55,
    width: 9.79,
    height: 16.76,
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.49 329.34 309.71 329.67 309.22 311.94 319.49 311.6 319.49 329.34",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.16,194.88c0,9.35-.38,85.74-.38,85.74.23,2.69,2.82,7.48,3,17.17.3,14-1.86,47.14-1.86,47.14a12.88,12.88,0,0,1-10.9.22s-7.69-46.82-9.45-60.72c-1.53-12.14-5.79-66.58-5.79-66.58l-7.49,51.78a55.58,55.58,0,0,1,1.22,15.56c-.46,6.43-6.42,38.65-6.42,38.65a13.36,13.36,0,0,1-11.3.87s-.58-50.58-.7-56.48c-.13-6.73,1.41-75.37,1.41-75.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,348.48v-1.4c-.53,0-.85.51-1.05,1.77-.15.9-.28,1.59-.58,2.77a32,32,0,0,1-1.71,5c-1.38,3.41-2.54,4.68-5.71,8.67a38.47,38.47,0,0,0-3,3.5c-.59,1.05-.8,4,.2,4.66,3.7,2.46,9.31,2.53,13.28,1.36a8,8,0,0,0,5.77-6.47c.14-.9.09-1.83.19-2.74a13,13,0,0,1,2.45-5.68,17,17,0,0,0,1.89-3.1c.82-2,.16-4.27-.37-6.28-.45-1.73-.94-3.63-1.53-3.47,0,.21,0,1.07,0,1.07-.71.79-2.68,1.57-4.9,1.65C352.19,349.86,348.72,349.57,348.73,348.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,326.65c0,.26-.91,1.06-2,2a39.56,39.56,0,0,1-3.36,2.6,62.87,62.87,0,0,1-7.49,4.7c-3.09,1.7-5.88,2.73-9.58,4.4a2.92,2.92,0,0,0-1,.69,2,2,0,0,0-.45.92,3.81,3.81,0,0,0,1.55,3.69,10.16,10.16,0,0,0,3.86,1.65,19.89,19.89,0,0,0,9.63.29,25.08,25.08,0,0,0,7.33-3.58,17.43,17.43,0,0,1,6.62-2.85c2.08-.3,4.63-.2,6.43-1.44,2-1.38,1.2-4.32.64-6.85-.62-2.76-1.39-7.07-2.31-6.88v1c-1.17,1.78-7.25,2.51-9.83,1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8,217.85A36.35,36.35,0,0,1,319.16,210s2.63,4.93,10.46,9.51l-3.79,47.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.18,123.16c3.33.8,10.05,1.9,11.55,8.54,1.81,8,2.4,25.32,2.4,25.32l.62,38.62c-6.74,4.91-32.9,7.58-47.09-2.78,0,0,3.13-46.37,3.13-53.59s4-15.88,15.09-16.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,122a28.89,28.89,0,0,0-5.5,10.7c-1.34,5.84-2.61,72.12-2.61,72.12s-7.57-.92-10.81-3.46c0,0-.66-54.17.69-62.59C311.18,123.88,311,122.4,327,121Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,121s-9.23,5.67-9.33,28.26c-.09,19.52.21,58.36.21,58.36s15.32,1,25-4.83c0,0-2-24.66-2.15-38.45,4-19.58,7.5-38.67,1.87-40.22S344.1,121,344.1,121Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.13 133.38 340.91 138.61 343.02 144.57 337.47 158.8 344.17 144.57 341.82 138.95 345.13 133.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.33 131.7 316.25 137.11 312.59 141.87 317.68 157.9 313.74 142.05 317.12 137.6 315.33 131.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.8,89.33a13.46,13.46,0,1,1-13.46-13.45A13.46,13.46,0,0,1,338.8,89.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,98.9s-2.18,10.24-3.06,11.92a4.62,4.62,0,0,1-2.68,2.17l.16-7.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,84.22A5.06,5.06,0,0,1,350,85.69c1.8,1.84.79,7.58-1.44,13.21l-4.11.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.26,99.37c.82.49,2-1.09,3-2.15s4.33-2.51,6,1-1.46,8.24-4.07,9.06c-4.5,1.41-5.17-1.47-5.17-1.47l-.34,18.37h0c-3.11,4-10.09,8.68-13.85,8-3-.54-3.66-5.61-.79-8.93v-6.59A28.16,28.16,0,0,1,322,117c-3.31-.51-5.4-3.12-6.39-6.7-1.52-5.47-2-11.61-.86-21.71,1.41-12.41,15.92-12.52,23.7-7.62S343.26,99.37,343.26,99.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.26,100.76c.41,0,2-2.61,3-3.54,1.42-1.29-.41-13-.41-13a5.66,5.66,0,0,0-1-6.31c-1.94-2.15-4.66-4.76-13.48-3.72-6.3.75-13.15,2.71-18.68,0a9.42,9.42,0,0,0,3.28,10s2,1.29,7.27,1.93a77.36,77.36,0,0,0,14.6-.28c1.53-.2,1.85,1.28,2.68,5.32C341.27,94.71,341.87,100.73,343.26,100.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,85.13l5-2.67a2.74,2.74,0,0,0-3.77-1.24A3,3,0,0,0,345.85,85.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05,116.64s7.39-1.49,10-2.86a8.49,8.49,0,0,0,3.56-3.53,11.58,11.58,0,0,1-2,4.16c-1.89,2.41-11.51,4.34-11.51,4.34Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,97.11a1.48,1.48,0,1,0,1.48-1.55A1.52,1.52,0,0,0,327.35,97.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.62,92.77l3.16,1.75A1.89,1.89,0,0,0,331,92,1.75,1.75,0,0,0,328.62,92.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,107.75,325.34,109a1.78,1.78,0,0,0,2.3,1.12A1.9,1.9,0,0,0,328.72,107.75Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,93.87l3.32-1.5a1.75,1.75,0,0,0-2.35-1A1.91,1.91,0,0,0,315.31,93.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,97.11a1.48,1.48,0,1,0,1.48-1.55A1.52,1.52,0,0,0,316,97.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.03 96.31 322.55 105.21 317.9 103.62 323.03 96.31",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,131.14c.91,2.15,2.58,3,5.62,3.37a11.28,11.28,0,0,0,8.4-2.92l-2.87-2.86-5.7,2.71-1.55-3.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.83,130a10,10,0,0,0-.5,4,6.94,6.94,0,0,0,1.35,3.37,3.67,3.67,0,0,0,3.26.35,8.9,8.9,0,0,0,3.11-6.75l-4.15.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,137.37c-3.23,12.66-5.18,34.2-4.79,36.37s2.82,10,4.69,10,5.16-7.75,4.91-9.73c-.47-3.77-2.33-36.66-1.55-36.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,137.72a3.28,3.28,0,0,1-3.26-.35l-.11.42a3.15,3.15,0,0,0,3.21.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9,131.44c5.86-2.95,12.94-7.26,13.88-12l.05-2.64s2.3.73,2.9,4.6c-.5,5.8-4.53,11.76-9.77,14.75L333.05,131Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,118.46a5.48,5.48,0,0,0-2.36,1.86C322.19,125,322.52,133,322.52,133l3.31-3,3.07,1.48a13.37,13.37,0,0,1-.86-8.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,124.16c4.58,1.18,7.61,1.55,10.75,7.54,2.73,5.21,15.33,27,18,32.23,1.34,2.59,2.67,5.55-.87,9.14-2.84,2.86-21.53,20.41-24.58,23.41a12.87,12.87,0,0,1-8.36,4c-4.75.42-7.07-1.26-7.91-2.29-5-6.19,4.6-7.13,7.91-9.18a16.69,16.69,0,0,0,4.06-3.49l-.2-3.28s3.5,0,4.62-.89S374.2,167.5,374.2,167.5s-14.26-18.77-16.09-22.7S354.2,127.18,359.69,124.16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,177.57l-2.29,3.14a8,8,0,0,0,1.86,5.5,13.78,13.78,0,0,0,5,4l3-2.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.35,178.77s.74,8.22,7.83,10.49c0,0,16.86-16.09,18.44-18.27s.48-4.47-2.91-10.42S371,130.33,368.79,127.8s-5.78-3-10.91-4.1a21.65,21.65,0,0,0-2.13,15.06c2,8.22,3.83,10.4,3.83,10.4l13.09,18.55Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-shaking-hands--inject-326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Girl--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.51,283.71a5,5,0,0,1-.75,2.94,36.43,36.43,0,0,1-4.84,6.35c-2.59,2.79-6.47,6.08-9.25,8.5-1.54,1.35-1.6,3.39.61,4.1a16.57,16.57,0,0,0,12.15-1.69c2.76-1.48,6.69-8.33,9-9.37,2.63-1.19,4.11-1.79,5-3,1.33-1.82,1.67-3.18.53-5.3-1.24-2.31-3.11-5.88-3.88-5.49l.24.74c-.6,1.89-5.75,4.09-8.39,3.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,296.51v-1.27c-.25,1.93-2.81,7.86-6.31,11.06-2.79,2.54-6.59,5.47-7.56,8.3s4.49,4.12,8.09,3.76a14.52,14.52,0,0,0,9.07-4.75c2.29-2.62,2.25-4.42,3.32-5.86s3.53-3.07,4.11-4.74c.32-.92-.06-2.93-.51-4.63s-.85-3.28-1.38-3.14v1a7,7,0,0,1-4.42,1.49C253.79,297.75,250.66,297.49,250.67,296.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.15,204c1.29-12.65,3.88-32.72,1-46.89-14.62-2.21-29.1-4.19-43.88-6-3.56,18.36-5.26,67.26-3.39,74.11,5.18,21,7.83,36.68,10.92,57.62a5.79,5.79,0,0,1-.68,4.09,30.67,30.67,0,0,1-4.18,5.66c-1.24,1.32-2.41,2.79-3.75,4.08a1.28,1.28,0,0,0-.39,1c.25,2,3.14,1.68,5.16,1a13.74,13.74,0,0,0,6.36-4.88c1.35-1.72,4-4.83,5.4-6.67a14,14,0,0,0,1.46-2.26,5,5,0,0,0,.27-3.34,8.56,8.56,0,0,1-.12-.88c-.08-2.87,2.78-34.11,1.93-41.24-.93-7.74-2-9.94-4.59-16.41,1.82-13.33,3.54-27.47,5.32-41,.31,14.62.37,31.3,2.25,45.33,1.5,11.23,2.23,19,3.42,30,1.14,10.55,2.52,30,2.65,32.89a30.45,30.45,0,0,1-.16,5.47,21.9,21.9,0,0,1-5.78,10.71c-.67.61-1.4,1.24-2.13,1.88-1.48,1.65-1.06,3.09,2.42,3.39s6.55-1.8,9.19-5c1.18-1.44,5.65-8.82,5.65-10.32h0c0-.44,0-.85,0-1.21a52.29,52.29,0,0,1,.73-8.2c1.46-8.64,4.6-24.22,5.12-31.13.83-11,0-16.31-2.79-25C263.62,220,263.89,216.29,265.15,204Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.25,143.36a171.35,171.35,0,0,0-5.05,28.71c-1.27,15.36-2.6,46.6-2,49.68s9.61,41.72,9.61,41.72a12.59,12.59,0,0,0,7.69,1.09,16.3,16.3,0,0,0,6.08-2.7s1.94-17.57,1.22-24.42-4.15-15-4.15-15L242,181.93s-.54,24.1.8,38.19,5.8,46.92,5.8,46.92a8.94,8.94,0,0,0,6.86,2.93,18.1,18.1,0,0,0,8.17-2.07s1.58-7.32,2.24-13.1a54.17,54.17,0,0,0-2.4-23.45s3.33-38.42,4.5-46.81,4.19-23.44-5.4-37.37C261.64,146.78,224.25,143.36,224.25,143.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,181.93v-1.81s-9-2.82-13.33-8.39c0,0,2.07,5.29,11,10.2,0,0-.19,23.72-.17,23.47S242,181.93,242,181.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,104.39c-3.21,9.45-8.57,36.6-8.57,36.6s-10,14.59-13.42,18.78c-1.71,2.11-5.41,6.3-5.41,6.3l8.37,6.58c6.06-7,15.2-16.29,19-21.11,1.8-2.31,3.3-4.29,3.78-6.32l3.81-24.15s0-19.3,3-21.84,3.8-3.06,3.8-3.06C229.76,95.9,221.79,97,219.27,104.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,95.9c-5.22-.6-11.9-.5-15.16,5.34s-8.69,35.92-8.69,35.92,5.13,4,10.68,3.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,124a54,54,0,0,1,1.09,13.68c-.42,6-4.71,17.1-4.71,17.1s3.38,3.07,12.58,1.63c7.48-1.17,4.84-23.75.54-28.12A14.19,14.19,0,0,0,220.79,124Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,96.33s12.5,1.44,14,2.11c-11.72,8.24-2.23,26.59-2.23,26.59l-4.49,14.07c2.88,3.7,5.54,6.52,7.78,9.61a31.12,31.12,0,0,1,4.19,7.61c3,7.83-30.45,20.27-48.71,5.85.73-4.53,1.89-9.24,2.93-13.46,1.43-5.85,2.65-10.78,2.24-13.07-5.25-16.17-5.57-19.08-4.64-22.69,2.62-10.15,13-17,15.52-17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,96.33s11.7,1,14,2.11,6.11,7.68,2.69,17.27-6.51,20.85-6.16,23.12,8.5,14,8.5,14c-2.37,1.53-4.88,3.12-7.5,3.6L256,147.28l1,9.69s-7.51,1.82-12.88,1.36C244.11,158.33,240.14,121.15,248.67,96.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,92.84h19.36a23.06,23.06,0,0,0,23.06-23.06h0a21.22,21.22,0,0,0-21.21-21.21h0A21.21,21.21,0,0,0,219,69.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.11,58.15c-2.25,1.32-5,7-4.74,18.77.23,10,3.48,12.48,5.11,13.2s4.77.28,7.82-.23v6s-4.22,4.9-4,7.66,6.09,3.4,10,.71,7.28-7.94,7.28-7.94l-.06-13.81s1.79,1.74,4.84-.92c2.52-2.2,3.37-5.91,1.41-7.91a4.39,4.39,0,0,0-7,1.39s-1.7-4.71-8.74-7C232.78,66,229.33,63.6,227.11,58.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,74a1.26,1.26,0,1,0,1.32-1.25A1.29,1.29,0,0,0,233.82,74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,82.89l-2.92.93a1.5,1.5,0,0,0,1.9,1.05A1.6,1.6,0,0,0,233.21,82.89Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,71l2.55-1.77a1.48,1.48,0,0,0-2.11-.43A1.63,1.63,0,0,0,223.63,71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.21,71.47l-2.55-1.77a1.5,1.5,0,0,1,2.12-.43A1.63,1.63,0,0,1,237.21,71.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,73.72a1.26,1.26,0,1,0,1.33-1.25A1.3,1.3,0,0,0,224.3,73.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.37 72.77 230.17 80.35 226.18 79.11 230.37 72.77",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,89.89c3.22-.43,9.85-2.33,10.88-5a6.81,6.81,0,0,1-2.32,3.34c-2,1.7-8.56,3.61-8.56,3.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,142c.92-5.52,0-7.32-1.95-12.73l-10.85,6.34s1.59,4.07,1.46,6.39c-.09,1.58-2.25,17.39-4.29,22.9a4.26,4.26,0,0,1-2,2.26c-2.47,1.32-3.53,2.77-5.43,4.51-1.5,1.36-2.71,1.64-2.56,2.12a2.3,2.3,0,0,0,2.87,1.24,16.34,16.34,0,0,0,3.48-1.58,21.42,21.42,0,0,1-3.84,5.66c-3.59,3.83-3.91,6.32,2.78,6.84,4.18.32,7.71-2,11.49-11a84,84,0,0,0,2.9-10.12C274.57,156.9,277.56,147.54,278.49,142Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.66,98.44c4.71,2.12,6.3,6.19,8.73,12.58,2.27,6,7.3,24.33,7.3,24.33s-5.7,5.63-12.24,4L258.11,119S254.19,105.7,262.66,98.44Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.69,368.56c-.71.27-1.12,1.62-1.44,4.91-.2,2-.89,4.73,2.22,6.38a7.86,7.86,0,0,0,7.34-.07c2.69-1.67,3.53-5.48,6.69-8,2.77-2.17,7.22-4.34,8.77-7.69,1.28-2.76,1.28-6.71-3.31-6.5-5.59.26-8.76,4.67-12.55,4.76C99.29,362.43,94.41,368.3,93.69,368.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,366.94l0,3.32c0,1.62,6.9,4,8.83.33.15-.32.9-4.86.9-4.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67,387.88s-1.31,0-1.82,5.35c-.2,2-.69,6.22,0,7.74s4.47,2.18,8.7,2.56c3.16.28,6,1.81,8.93,3.46a19.42,19.42,0,0,0,9.06,2.5c4,0,7.39-.4,10.24-2.66,1.52-1.2,3.44-3.73,2-5.63a4.16,4.16,0,0,0-2.14-1.13c-1.78-.66-3.57-1.27-5.39-1.84a55.77,55.77,0,0,1-7.92-3c-3.73-1.84-7.89-3.9-10.71-7.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.69,385.11s0,2.46,0,3.87,1.64,3.51,5.94,3.38c3-.09,5.13-.89,5-3.38l0-3.59Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,322.9a89.93,89.93,0,0,1,4-17.26s-1.11-14.92-1.6-29.06a371.89,371.89,0,0,1,1.21-43.43s48-4.56,48.83,13.1-.35,62.57-1,70.32-1.24,15-2.88,29.44c-1.41,12.42-3.69,39.38-3.69,39.38a11.63,11.63,0,0,1-11-.28s-3.62-36.2-4-45.14c-.54-11.6,2.17-18,2.17-18s-1-7.29-2.82-22.29c-1.26-10.6-2.94-22.67-2.94-22.67s-1.64,14.94-2.64,23.27c-.92,7.72-2.49,13.82-4.81,28.21-2,12.49-7.49,38.91-7.49,38.91-5.65,3-9.43-.46-9.43-.46S90.19,333.73,91.77,322.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,277l-2.27-14.74s-9.35-3-14.11-8.54c0,0,2.54,6.48,11.25,10l3.49,12.42.6,10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.26,174c-7.49-1.81-12.23,1.82-15,12-2.37,8.74-5.84,26.82-7.19,33.57-.5,2.5-1.48,5.37,3.78,8.52A232.29,232.29,0,0,0,110.43,240l2.88-10.77L101.69,205.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.26,174c-7.49-1.81-12.23,1.82-15,12-2.37,8.74-5.84,26.82-7.19,33.57-.5,2.5-1.48,5.37,3.78,8.52A232.29,232.29,0,0,0,110.43,240l2.88-10.77L101.69,205.4Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.96 169.21 123.72 184.98 109.53 184.49 110.9 166.07 125.96 169.21",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,149.75s3.81,5.58,3.39,6.14-3.14,1.1-3.14,1.1Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,148.83a4.63,4.63,0,1,1,4.7,4.56A4.63,4.63,0,0,1,130.19,148.83Zm1,0a3.6,3.6,0,1,0,3.54-3.66A3.6,3.6,0,0,0,131.22,148.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,134.31c7.54,1.47,9.77,4.74,10.66,16.68.94,12.47-.27,16.41-1.88,18.12-1.09,1.15-7.24,1.45-10.36.65-3.9-1-12.73-4-16.94-10.2-5-7.31-6.38-17.3-1.27-21.49C113,132.17,122.51,133.72,125.58,134.31Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,170.08c3.25.35,7.61,0,8.52-1-3.63.23-8.08-1.59-8.08-1.59Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41,137.32l-.23.24c-1.49,1.46-3.41,2.4-5,3.78a11.74,11.74,0,0,0-3.48,5.75c-.49,1.82-.66,4-2.62,4.84,0,0-1.32-4.81-5.38-4.14s-4.55,5.91-1.92,9,5,1.87,5,1.87,0,6.91-3,10.86c0,0-3.46,1.18-9.88-.08-4-.78-9.59-5.6-12-10.77-5.12-10.94-5.62-20.84,1.36-23.93.68-5.08,4.64-7.42,9.18-8.54,6.79-1.67,13.23,2.27,19.94.66,1.41-.34,2.77-.87,4.2-1.07a.9.9,0,0,1,.49,0c.35.17.33.66.24,1a8.8,8.8,0,0,1-1.93,3.66,21,21,0,0,0,7.62-1.08A9.81,9.81,0,0,1,137.41,137.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28,137.24l-4.54-2.58a2.61,2.61,0,1,1,4.54,2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.18,154.63l-.22-5.22a2.61,2.61,0,0,1,.22,5.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139 147.73 125.04 149.76 125.62 150.73 139.02 148.78 139 147.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,182.25c1.66-6.48,4-8.59,9.63-8.74a73.38,73.38,0,0,1,8.66,1.11c.59,2.73,7.66,4.59,14.81,3.11,2.13.62,7.76,2.16,9.52,2.8,5.06,1.83,7.52,7.09,7.85,23.77,0,0,1,39.56,0,46.39-12.76,5-26,4.75-33.32,3.12-15.22-3.41-17-9.74-17-9.74s.8-15.88,1.31-27.95c-.76-7.69-1.91-13.47-2.32-19.61A51.67,51.67,0,0,1,93.87,182.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.23,179.52c1.23-3.12,3-8.68,5.94-12.48s4-6.59,5.13-4.93c1.52,2.2-1.91,6.6-1.15,7s3.62,6.23,3.91,9.45-8.24,11.32-8.24,11.32Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,180.53a15.81,15.81,0,0,1,7.09,3.34c3.55,3,21.47,17,21.47,17l16.1-23.35,7.88,9.07s-11.8,22.46-16.74,30.86c-1.54,2.63-5.44,3.12-12.17-.76-5.6-3.23-24-14.78-24-14.78S131.53,188.56,136.49,180.53Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.52,180.2a13.88,13.88,0,0,1,5.35,1.41c2.67,1.36,24.18,18.86,24.18,18.86l5.49-7.53c4.43,1.12,7.68,3.15,11.08,7.62,0,0-6,12.81-8.52,17.12s-4.7,3.38-9.48,1.32-24.49-13.6-24.49-13.6-5.61-3.83-6.49-10.23C131,183,135.52,180.2,135.52,180.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.52,180.2a13.88,13.88,0,0,1,5.35,1.41c2.67,1.36,24.18,18.86,24.18,18.86l5.49-7.53c4.43,1.12,7.68,3.15,11.08,7.62,0,0-6,12.81-8.52,17.12s-4.7,3.38-9.48,1.32-24.49-13.6-24.49-13.6-5.61-3.83-6.49-10.23C131,183,135.52,180.2,135.52,180.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05,200.47a62.39,62.39,0,0,1,4.55,4.93s-.12-3.08-3.6-6.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,192.94l2.8-4.06a15.41,15.41,0,0,1,6.46,2.61,12.44,12.44,0,0,1,4.26,4.51l-2.44,4.56A26.43,26.43,0,0,0,170.54,192.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,192.94l2.8-4.06a15.41,15.41,0,0,1,6.46,2.61,12.44,12.44,0,0,1,4.26,4.51l-2.44,4.56A26.43,26.43,0,0,0,170.54,192.94Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,196.51a.75.75,0,0,1-1.5,0,.75.75,0,0,1,1.5,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,170.52l-.12,1.52s.75,2.14,5,2.94c7.24,1.35,9.77-.9,9.77-.9l.18-1.3s.7-.29,1.87.61a65.1,65.1,0,0,1,5,5.87s-1.38-.41-5.9,1.52a21.59,21.59,0,0,1-14.12.53,7.77,7.77,0,0,1-5.15-5.79C107,174.2,109.32,170,110.57,170.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,170.52l-.12,1.52s.75,2.14,5,2.94c7.24,1.35,9.77-.9,9.77-.9l.18-1.3s.7-.29,1.87.61a65.1,65.1,0,0,1,5,5.87s-1.38-.41-5.9,1.52a21.59,21.59,0,0,1-14.12.53,7.77,7.77,0,0,1-5.15-5.79C107,174.2,109.32,170,110.57,170.52Z",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hands--inject-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.91,168.65s10.31-.89,11.82,0,1.05,5.35,0,8.09-6.31,4.52-11.19,7.82C190.53,184.07,189.91,168.65,189.91,168.65Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,184.54c2-1.47,2-3.27,2.42-6.14s8.27-6,8.52-3.82,1,3.93-1.46,6.52S194.15,186.47,190.54,184.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.09,166.07c-1.88,2.44-2.2,5.32-3.19,6.91s-2.5,3.42-.32,3.71,4.83-2.55,6-5.14a6.22,6.22,0,0,1,3.18-3.28c-1-.35-.49-4.46-1.21-5C195.58,163.25,191.87,164.76,191.09,166.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.b016fd0abc3534a754f5b73ec21a953a.svg";
export { ForwardRef as ReactComponent };